import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

type Props = {
	isOpen: boolean,
	handleClose: () => void,
	handleConfirmantion: () => void,
};

export default (props: Props) =>
	<Dialog open={props.isOpen} onClose={props.handleClose}>
		<DialogTitle>Bestätigung Resync</DialogTitle>
		<DialogContent>
			<DialogContentText>
				Sind Sie sicher, sie wollen den Resync ausführen? Dieser Vorgang löscht alle Tasks und synchronisiert sie neu.
			</DialogContentText>
		</DialogContent>
		<DialogActions>
			<Button onClick={props.handleClose}>Cancel</Button>
			<Button onClick={props.handleConfirmantion} color='primary'>
				Resync
			</Button>
		</DialogActions>
	</Dialog>